/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Christian Santa Maria <csantamaria@smartboxtv.com>
 */

import { observable, action, ObservableMap, computed } from 'mobx';
import {
    generateDetail,
    generateList,
    generateListRefresh,
    generateCreate,
    generateUpdate,
    generateListMore,
    generateDelete,
    generateReplace
} from './actionCreator';
import _ from '../translations';
import map from  'lodash/map';
import get from  'lodash/get';

class AddonsStore {
    constructor() {
        this.baseUrl = '/api/generic/addons';
    }

    @observable collection = new ObservableMap();
    @observable details = new ObservableMap();

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action.bound
    async detail({ _id = false } = {}) {
        return await generateDetail({
            _id,
            url: `${this.baseUrl}/${_id}`,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem fetching the news'),
        })();
    }

    @action.bound
    async list({ hash, params = {} } = {}) {
        params.notExists = 'termsAndConditions';

        return await generateList({
            hash,
            params,
            url: this.baseUrl,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem listing news'),
        })();
    }

    @action.bound
    async listRefresh({ hash, params = {}, maxPagesToRefresh } = {}) {
        params.notExists = 'termsAndConditions';

        return await generateListRefresh({
            hash,
            params,
            url: this.baseUrl,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem listing news'),
            maxPagesToRefresh,
        })();
    }

    @action.bound
    async listMore({ hash, params = {} } = {}) {
        params.notExists = 'termsAndConditions';

        return await generateListMore({
            hash,
            params,
            url: this.baseUrl,
            store: this,
            disableClientFilter: true,
            customError: _('There was a problem listing news'),
        })();
    }

    @action.bound
    async create({ item = {} } = {}) {
        return await generateCreate({
            item,
            url: this.baseUrl,
            store: this,
            customError: _('There was a problem creating the news'),
        })();
    }

    @action.bound
    async update({ items, item = {} } = {}) {
        return await generateUpdate({
            items,
            item,
            url: `${this.baseUrl}/multiple`,
            store: this,
            customError: _('There was a problem updating the news'),
        })();
    }   

    @action.bound
    async put({ items, item = {} } = {}) {
        return await generateReplace({
            items,
            item,
            url: `${this.baseUrl}/multiple`,
            store: this,
            customError: _('There was a problem updating the news'),
        })();
    }

    @action.bound
    async delete({ items, _id = false, type = 'logical' } = {}) {
        return await generateDelete({
            items,
            _id,
            type,
            url: `${this.baseUrl}/multiple`,
            store: this,
            customError: _('There was a problem deleting the news'),
        })();
    }

    @computed
    get forSelect() {
        const page = this.collection.get('listAddons');
        const items = map(page ? page.items : {}, item => ({
            text: get(item ,'title.original', 'Empty name'),
            value: item._id,
        }));
        return items;
    }
}

export default new AddonsStore();
